<template>
    <tr>
        <!-- for mobile -->
        <td class="is-hidden-tablet">
            <p class="mb-0">
                <span class="has-text-weight-medium">
                    {{ row.dteRegisteredDate | formatDate }}
                </span>
                <span v-if="row.strDescription">
                    <br />
                    {{ row.strDescription | truncate(5) }}
                </span>
                <span v-if="row.strJobStatus">
                    <br />
                    <small class="is-size-7 has-text-grey">
                        {{ row.strJobStatus | uppercase }}
                    </small>
                </span>
            </p>
        </td>
        <td
            v-if="! $meta.features.owners.works_orders_hide_estimate"
            class="is-hidden-tablet"
        >
            <span v-if="row.dblEstimatedCost">
                &pound;{{ row.dblEstimatedCost | currency }}
            </span>
        </td>

        <!-- for tablet and up -->
        <td class="is-hidden-mobile">
            {{ row.dteRegisteredDate | formatDate }}
        </td>
        <td class="is-hidden-mobile">
            {{ row.strDescription }}
        </td>
        <td
            v-if="! $meta.features.owners.works_orders_hide_estimate"
            class="is-hidden-mobile"
        >
            <span v-if="row.dblEstimatedCost">
                &pound;{{ row.dblEstimatedCost | currency }}
            </span>
        </td>
        <td class="is-hidden-mobile">
            {{ row.strJobStatus }}
        </td>
        <td class="is-hidden-mobile">
            {{ row.dteCompleted | formatDate }}
        </td>
    </tr>
</template>

<script>
export default {
    props: {
        row: {
            type: Object,
            required: true,
        },
    },
};
</script>
